<template>
    <div class="statistics-container">
        <div class="header">
            <div class="title">事件统计</div>
            <CardTabs :data="['日', '周', '月']" 
                :TabsStyle="TabsStyle"
                @changed="dateChanged"
                :checked="time">
            </CardTabs>
        </div>
        <div class="content" v-if="status === 'loading'" v-loading="status === 'loading'">
            
        </div>
        <div class="content" v-else-if="status === 'error'">
            error
        </div>
        <template v-else>
            <div class="row-center land">
                <div class="pie">
                    <PieCharts :pieData="pieData" :total="total"></PieCharts>
                </div>
                <div class="panelright row-center" style="justify-content: space-between;">
                    <div class="item column-center">
                        <div class="name">紧急</div>
                        <div class="num" style="color:#FF5555">{{data.urgent}}</div>
                    </div>
                    <div class="item column-center">
                        <div class="name">隐患</div>
                        <div class="num" style="color:#F5AA00">{{data.hiddenDanger}}</div>
                    </div>
                    <div class="item column-center">
                        <div class="name">通知</div>
                        <div class="num" style="color:#0D94FF">{{data.notice}}</div>
                    </div>
                </div>
            </div>
            
            <!-- <div class="legend">
                <PieLengend v-for="(item, index) in data" :key="index" :item="item" ></PieLengend> 
            </div> -->
            <div class="haoroomflex">
                <div v-for="(item,index) in barData" :key="index" class="onebar">
                <div class="sval">{{ item.value }}</div>
                <div class="bar">
                    <span class="progress" :style="{'height':`${(item.value==0&&item.total==0)?0:(item.value/item.total)*100}%`}" />
                </div>
                <div class="sfont">{{ item.name }}</div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import CardTabs from './shared/CardTabs';
import PieCharts from './statistics/PieCharts';
import PieLengend from './statistics/PieLegend';

export default {
    props: {
        data: Object,
        time: Number,
        status: String,
    },
    components: { 
        CardTabs,
        PieCharts,
        PieLengend
    },
    data () {
        return {
            TabsStyle: {
                // width: '121rem'
            },
            total:0
        //     barData: [
		//      { date: '保护动作', value: 0 },
		//      { date: '故障报警', value: 0 },
		//      { date: '开关变位', value: 0 },
		//      { date: '越限异常', value: 0 },
		//      { date: '信息通报', value: 0 },
		//      { date: '操作命令', value: 0 },
		//      { date: '其他告警', value: 0 }
		//   ],
        }
    },
    computed: {
        barData(){
            // fault: 0  故障报警
            // hiddenDanger: 0  隐患
            // messageNotice: 0 信息通报
            // notice: 7 通知
            // operation: 0  操作命令
            // other: 0  其他
            // overrun: 0 越限异常
            // protections: 0 保护动作
            // sum: 7 总
            // switchDisplacement: 7  开关变位
            // urgent: 0 紧急
            return [
                { name: '保护动作', value: this.data.protections,total:this.data.urgent },
                { name: '故障报警', value: this.data.fault,total:this.data.urgent },
                { name: '开关变位', value: this.data.switchDisplacement,total:this.data.notice},
                { name: '越限异常', value: this.data.overrun,total:this.data.hiddenDanger},
                { name: '信息通报', value: this.data.messageNotice,total:this.data.notice },
                { name: '操作命令', value: this.data.operation,total:this.data.notice },
                { name: '其他告警', value: this.data.other,total:0 }
            ]
        },
        pieData: function () {
            // return this.data.map(item => {
            //     return {
            //         name: item.name,
            //         value: item.num,
            //         itemStyle: {
            //             color: item.color
            //         }
            //     }
            // })
            this.total = this.data.sum
            return [{
                name: "紧急",
                value: this.data.urgent?this.data.urgent:0,
                itemStyle: {
                    color: "#FF5555"
                }
            },{
                name: "隐患",
                value: this.data.hiddenDanger?this.data.hiddenDanger:0,
                itemStyle: {
                    color: "#F5AA00"
                }
            },{
                name: "通知",
                value: this.data.notice?this.data.notice:0,
                itemStyle: {
                    color: "#0D94FF"
                }
            }]
        },
        // total: function () {
        //     // return this.data.reduce((prev, current) => {
        //     //     return {
        //     //         num: prev.num + current.num
        //     //     }
        //     // })
        //     return this.data.sum
        // }
    },
    methods: {
        dateChanged: function (index) {
            this.$emit('changed', index);
        }
    }
}
</script>

<style lang="less" scoped>
    .land{
        padding: 0 24px;
        height: 150rem;
        .pie{
            width: 100rem;
            height: 100%;
        }
    }
    .panelright{
        // justify-content: space-between;
        // flex-flow: column;
        width: 80%;
        .item{
            width: 32%;
            height: 100rem;
            background: rgba(13, 148, 255, 0.04);
            border-radius: 8rem;
            text-align: center;
            
            .name{
                font-size: 17px;
                // margin-top: 30px;
            }
            .num{
                font-size: 24px;
                font-weight: bold;
                margin-top: 5px;
            }
        }
    }

    .haoroomflex{
		display: flex;
		font-size:16px;
		.onebar{
			 flex:1;
			 text-align: center;
			//  min-width: 30px;
			//  max-width: 100px;
			 display: inline-block;
			 .sval{
				 color: #333333;
			 }
			 .sfont{
			  color: #666666;
			  margin-top: 28px;
			 }
			 .bar{
			   height: 168px;
			   width:16px;
			   margin:6px auto;
			   border-radius: 8px;
			   overflow: hidden;
			   position: relative;
			   background: #E0E5EC;
				  .progress {
					position: absolute;
					bottom:0;
					height: 0;
					width: 100%;
					display: block;
					border-radius: 8px;
					-webkit-transition: height 1s ease-out;
					-o-transition: height 1s ease-out;
					transition: height 1s ease-out;
					background: linear-gradient(0deg, #F6BD16 0%, #E8684A 100%);
				   }
			  }
		}
	}
	
.statistics-container {
    .h(520);
    .w(796);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
    display: flex;
    flex-direction: column;

    .header {
        display: flex;
        justify-content: space-between;
        padding-left: 24rem;
        padding-right: 24rem;
        height: 64rem;
        line-height: 64rem;

        .title {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }

    .pie {
        flex: 1;
    }

    .legend {
        .h(150);
        order: 1;

        display: flex;
        justify-content: space-around;
        align-items: center;
    }
}
</style>